import { DisplayPosition } from '@/common/manager/position/display-position';
import { CnNumberPicker, componentMap as formComponentMap, } from '@cainiaofe/cn-ui';
import { handleBizExtendComponentProps } from '@/common/manager/plugin';
import { setAdvancedConfigToProps } from '@/common/util/util';
export const config = {
    position: [
        DisplayPosition.form,
        DisplayPosition.formDialog,
        DisplayPosition.filter,
        DisplayPosition.cnArrayTable,
        DisplayPosition.cnArraySubAreaCard,
    ],
    formItemBeforeHandler: (formItem) => {
        if (formItem) {
            const componentProps = formItem['x-component-props'];
            handleBizExtendComponentProps(componentProps, 'CnNumberPicker');
            setAdvancedConfigToProps(componentProps);
        }
    },
    componentName: 'NumberPicker',
    component: CnNumberPicker,
    formComponent: formComponentMap.CnNumberPicker,
};
